import axios from 'axios'

import config from '../service/config';

const ANONYMOUS_CLIENT_ID = process.env.REACT_APP_ANONYMOUS_CLIENT_ID || '';
const ANONYMOUS_CLIENT_SECRET = process.env.REACT_APP_ANONYMOUS_CLIENT_SECRET || '';

const auth = (() => {
  let anonymousToken = null;
  let anonymousTokenExpiration = null;

  const getAnonymousToken = () => {
    const currentTime = Date.now();

    // Check if the token is still valid
    if (anonymousToken && anonymousTokenExpiration && currentTime < anonymousTokenExpiration) {
      return anonymousToken;
    }

    const authorizationBasic = btoa(`${ANONYMOUS_CLIENT_ID}:secret`);

    const params = new URLSearchParams({
      grant_type: 'client_credentials',
      client_secret: ANONYMOUS_CLIENT_SECRET,
      client_id: ANONYMOUS_CLIENT_ID,
    });

    return axios.post(config.oauthUrl, params.toString(), {
      headers: {
        Authorization: 'Basic ' + authorizationBasic,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    }).then((result) => {
      if (result.data) {
        anonymousToken = result.data.access_token;
        anonymousTokenExpiration = currentTime + (result.data.expires_in * 1000);
        return anonymousToken;
      }      
    });
  };

  const ensureToken = async () => {
    const accessToken = config.getAccessToken()?.trim();
    return accessToken || await getAnonymousToken();
  };

  return {
    getAnonymousToken,
    ensureToken,
  };

})();

export default auth;
